module.exports = {
    STARTUP_TITLE_TEXT: {
        DEFAULT: "Welcome to PriceMe!",
        NO_CURRENT_AREA: "Where do you want to play? Choose an area!",
        START_WEEK: `It's a new week on PriceMe!`,
        CONTINUE: `Here's where you're at. Let's go!`,
        TOP_USER: `You're doing great. Keep it up!`,
    },
};
